if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          viewer: '[id^="GalleryViewer"]',
          thumbnails: '[id^="Slider-Thumbnails"]',
          thumbnailsContainer: '.product__media-gallery-thumbnails',
          mediaList: '.product__media-list',
          mediaItems: ['.product__media-item'],
        };

        this.sliderInstance = false;
        this.thumbsInstance = false;
      }

      connectedCallback() {
        this.init();
      }

      init() {
        this.elements = {
          viewer: this.querySelector(this.selectors.viewer),
          thumbnails: this.querySelector(this.selectors.thumbnails),
          thumbnailsContainer: this.querySelector(this.selectors.thumbnailsContainer),
          mediaList: this.querySelector(this.selectors.mediaList),
        };

        this.mediaLayout = this.dataset.mediaLayout;
        this.onlyImage = this.dataset.onlyImage === 'true';
        this.enableDesktopSlider = this.dataset.enableDesktopSlider === 'true';
        this.enableMobileThumbnails = this.dataset.enableMobileThumbnails === 'true';
        this.enableImageZoom = this.dataset.enableImageZoom === 'true';
        this.context = this.dataset.context;
        this.isMobile = window.innerWidth < 768;
        this.setSliderOptions();
        this.setupEventListeners();
        this.updateMediaLayout();

        // Initialize mobile scrolling if on mobile
        if (this.isMobile) {
          this.initMobileScrolling();
        }

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.updateMediaLayout.bind(this);
      }

      setSliderOptions() {
        const mediaItemGap = parseInt(this.dataset.mediaItemGap);
        const mediaItemGapMobile = parseInt(this.dataset.mediaItemGapMobile);

        this.sliderOptions = {
          init: false,
          slidesPerView: this.enableMobileThumbnails ? 1 : 'auto',
          spaceBetween: mediaItemGapMobile,
          loop: true,
          grabCursor: true,
          allowTouchMove: true,
          autoHeight: true,
          breakpoints: {
            768: {
              spaceBetween: mediaItemGap,
            },
          },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'fraction',
          },
          threshold: 2,
        };

        this.thumbsOptions = {
          slidesPerView: 4,
          breakpoints: {
            461: {
              slidesPerView: 5,
              direction: 'horizontal',
            },
          },
          spaceBetween: mediaItemGapMobile,
          loop: false,
          freeMode: true,
          watchSlidesProgress: true,
          threshold: 2,
          breakpoints: {
            768: {
              spaceBetween: mediaItemGap,
            },
          },
        };

        switch (this.mediaLayout) {
          case 'vertical-carousel':
            this.thumbsOptions.breakpoints = {
              ...this.thumbsOptions.breakpoints,
              768: {
                direction: 'vertical',
                slidesPerView: 'auto',
                spaceBetween: mediaItemGap,
              },
            };
            break;
          case 'carousel':
            this.thumbsOptions.breakpoints = {
              ...this.thumbsOptions.breakpoints,
              1024: {
                slidesPerView: 5,
              },
              1536: {
                slidesPerView: 7,
              },
            };
            break;
        }
      }

      setupEventListeners() {
        window.addEventListener('resize', this.updateMediaLayout.bind(this));
      }

      cleanupEventListeners() {
        window.removeEventListener('resize', this.updateMediaLayout);
      }

      updateMediaLayout() {
        this.isMobile = window.innerWidth < 768;

        if (this.isMobile) {
          this.cleanupSlider();
          this.initMobileScrolling();
        } else {
          this.cleanupMobileScrolling();
          this.initSlider();
        }

        if (this.sliderInstance) {
          this.forceSliderUpdate();
        }
        console.log('Media layout update complete');
      }

      cleanup() {
        this.cleanupSlider();
        this.cleanupMobileScrolling();
        this.cleanupEventListeners();
      }

      initMobileScrolling() {
        if (!this.elements.mediaList) return;

        // Add mobile-specific classes
        this.elements.mediaList.classList.add('mobile-scroll');

        // Make sure each slide takes full width
        const slides = this.elements.mediaList.querySelectorAll('.product__media-item');
        slides.forEach(slide => {
          slide.style.minWidth = '100%';
          slide.style.boxSizing = 'border-box';
        });

        // Add padding to first and last items
        if (slides.length > 0) {
          slides[0].style.paddingLeft = '20px';
          slides[slides.length - 1].style.paddingRight = '20px';
        }

        console.log('Mobile scrolling initialized');
      }

      cleanupMobileScrolling() {
        if (!this.elements.mediaList) return;

        // Remove mobile-specific classes and styles
        this.elements.mediaList.classList.remove('mobile-scroll');
        const slides = this.elements.mediaList.querySelectorAll('.product__media-item');
        slides.forEach(slide => {
          slide.style.minWidth = '';
        });
      }

      initSlider() {
    // Add mobile-specific classes
    this.elements.mediaList.classList.add('mobile-scroll');
    
    // Make sure each slide takes full width
    const slides = this.elements.mediaList.querySelectorAll('.product__media-item');
    slides.forEach(slide => {
      slide.style.minWidth = '100%';
      slide.style.boxSizing = 'border-box';
    });
    
  }
  
  cleanupMobileScrolling() {
    if (!this.elements.mediaList) return;
    
    // Remove mobile-specific classes and styles
    this.elements.mediaList.classList.remove('mobile-scroll');
    const slides = this.elements.mediaList.querySelectorAll('.product__media-item');
    slides.forEach(slide => {
      slide.style.minWidth = '';
    });
  }
  
  initSlider() {
        console.log('Initializing slider...');
        if (!this.elements.viewer) {
          console.error('Slider container not found');
          return;
        }

        // Check if mobile
        const isMobile = window.innerWidth < 768;
        console.log('Is mobile:', isMobile);

        // Destroy existing slider instance if it exists
        if (this.sliderInstance) {
          console.log('Destroying existing slider instance');
          this.destroySlider();
        }

        try {
          console.log('Creating new Swiper instance');
          
          // Update slider options for mobile
          const sliderOptions = {
            ...this.sliderOptions,
            slidesPerView: 1,
            spaceBetween: 0,
            centeredSlides: true,
            loop: false,
            watchOverflow: true,
            watchSlidesProgress: true,
            resizeObserver: true,
            breakpoints: {
              // Mobile breakpoint
              320: {
                slidesPerView: 1,
                spaceBetween: 10,
                allowTouchMove: true
              },
              // Tablet breakpoint
              768: {
                slidesPerView: this.sliderOptions.slidesPerView,
                spaceBetween: this.sliderOptions.spaceBetween,
                allowTouchMove: this.sliderOptions.allowTouchMove
              }
            }
          };
          
          // Initialize thumbnails if needed
          if ((this.enableDesktopSlider || this.enableMobileThumbnails) && this.elements.thumbnails) {
            const thumbsOptions = {
              ...this.thumbsOptions,
              breakpoints: {
                320: {
                  slidesPerView: 4,
                  spaceBetween: 8,
                  direction: 'horizontal'
                },
                768: this.thumbsOptions.breakpoints
              }
            };
            
            this.thumbsInstance = new Swiper(this.elements.thumbnails, thumbsOptions);
            sliderOptions.thumbs = {
              swiper: this.thumbsInstance,
              autoScrollOffset: 2,
            };
          }

          // Initialize main slider
          this.sliderInstance = new Swiper(this.elements.viewer, {
            ...sliderOptions,
            on: {
              afterInit: this.handleSliderAfterInit.bind(this),
              slideChange: this.handleSlideChange.bind(this),
              resize: () => {
                console.log('Window resized, updating slider');
                this.handleResize();
              },
              init: () => {
                console.log('Swiper initialized successfully');
                // Force update to ensure proper rendering
                this.forceSliderUpdate();
              }
            },
          });

          // Force update after a short delay to ensure DOM is ready
          setTimeout(() => {
            this.forceSliderUpdate();
          }, 500);
          
          // Add resize event listener
          window.addEventListener('resize', this.handleResize.bind(this));
          
        } catch (error) {
          console.error('Error initializing Swiper:', error);
        }
      }

      destroySlider() {
        // Remove resize event listener
        window.removeEventListener('resize', this.handleResize);
        
        if (this.sliderInstance) {
          try {
            this.sliderInstance.destroy(true, true);
            this.sliderInstance = null;
            console.log('Slider destroyed');
          } catch (error) {
            console.error('Error destroying slider:', error);
          }
        }
        
        if (this.thumbsInstance) {
          try {
            this.thumbsInstance.destroy(true, true);
            this.thumbsInstance = null;
            console.log('Thumbnails slider destroyed');
          } catch (error) {
            console.error('Error destroying thumbs slider:', error);
          }
        }
      }

      initThumbsSlider() {
        if (typeof this.thumbsInstance !== 'object') {
          this.thumbsInstance = new window.FoxTheme.Carousel(this.selectors.thumbnails, this.thumbsOptions);
          this.thumbsInstance.init();
        }
      }

      initImageZoom() {
        let dataSource = [];
        const allMedia = [...this.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)')];
        if (allMedia) {
          allMedia.forEach((media) => {
            switch (media.dataset.mediaType) {
              case 'model':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  html: `<div class="pswp__item--${media.dataset.mediaType}">${
                    media.querySelector('product-model').outerHTML
                  }</div>`,
                  mediaType: media.dataset.mediaType,
                });
                break;
              case 'video':
              case 'external_video':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  html: `<div class="pswp__item--${media.dataset.mediaType}">${
                    media.querySelector('video-element').outerHTML
                  }</div>`,
                  mediaType: media.dataset.mediaType,
                });
                break;
              case 'image':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  src: media.dataset.src,
                  width: media.dataset.pswpWidth,
                  height: media.dataset.pswpHeight,
                  mediaType: media.dataset.mediaType,
                });
                break;
            }
          });
        }

        this.lightbox = new window.FoxTheme.PhotoSwipeLightbox({
          dataSource: dataSource,
          pswpModule: window.FoxTheme.PhotoSwipe,
          bgOpacity: 1,
          arrowPrev: false,
          arrowNext: false,
          zoom: false,
          close: false,
          counter: false,
          preloader: false,
        });

        this.lightbox.addFilter('thumbEl', (thumbEl, { id }, index) => {
          if (this.sliderInstance && this.sliderInstance.slider) {
            const { slides, activeIndex } = this.sliderInstance.slider;
            if (slides[activeIndex]) {
              const el = slides[activeIndex].querySelector('img');
              if (el) {
                return el;
              }
            }
          }

          return thumbEl;
        });

        this.lightbox.addFilter('placeholderSrc', (placeholderSrc, { data: { id } }) => {
          if (this.sliderInstance && this.sliderInstance.slider) {
            const { slides, activeIndex } = this.sliderInstance.slider;
            if (slides[activeIndex]) {
              const el = slides[activeIndex].querySelector('img');
              if (el) {
                return el.src;
              }
            }
          }

          return placeholderSrc;
        });

        this.lightbox.on('change', () => {
          window.pauseAllMedia(this);
          if (this.sliderInstance && this.sliderInstance.slider) {
            const { currIndex } = this.lightbox.pswp;
            if (this.sliderInstance.slider.realIndex !== currIndex) {
              this.sliderInstance.slider.slideToLoop(currIndex, 100, false);
            }
          }
        });

        this.lightbox.on('pointerDown', (e) => {
          if (this.lightbox.pswp.currSlide.data.mediaType != 'image') {
            e.preventDefault();
          }
        });

        this.lightbox.on('uiRegister', () => {
          if (!this.onlyImage) {
            this.lightbox.pswp.ui.registerElement({
              name: 'next',
              ariaLabel: 'Next slide',
              order: 3,
              isButton: true,
              html: '<svg class="pswp-icon-next flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
              onClick: (event, el) => {
                this.lightbox.pswp.next();
              },
            });
            this.lightbox.pswp.ui.registerElement({
              name: 'prev',
              ariaLabel: 'Previous slide',
              order: 1,
              isButton: true,
              html: '<svg class="pswp-icon-prev rtl-flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
              onClick: (event, el) => {
                this.lightbox.pswp.prev();
              },
            });
          }
          this.lightbox.pswp.ui.registerElement({
            name: 'close-zoom',
            ariaLabel: 'Close zoom image',
            order: 2,
            isButton: true,
            html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
            onClick: (event, el) => {
              this.lightbox.pswp.close();
            },
          });
        });

        this.lightbox.init();

        FoxTheme.utils.addEventDelegate({
          selector: '.js-photoswipe--zoom',
          context: this,
          handler: (e, media) => {
            if (media.dataset.mediaType === 'image') {
              const index = Number(media.dataset.mediaIndex) || 0;
              this.lightbox.loadAndOpen(index);
            }
          },
        });
      }

      handleSliderAfterInit() {
        this.sliderInstance.slider.on('afterInit', (swiper) => {
          const { slides, activeIndex } = swiper;

          if (slides[activeIndex]) {
            const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
            this.toggleSliderDraggableState(!isModelMediaType);
          }
        });
      }

      handleSlideChange() {
        this.sliderInstance.slider.on('realIndexChange', (swiper) => {
          const { slides, activeIndex, thumbs } = swiper;

          if (thumbs.swiper) {
            thumbs.swiper.slideTo(activeIndex);
          }

          if (slides[activeIndex]) {
            this.playActiveMedia(slides[activeIndex]);

            const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
            this.toggleSliderDraggableState(!isModelMediaType);
          }
        });
      }

      toggleSliderDraggableState(isDraggable) {
        if (this.sliderInstance.slider.allowTouchMove !== isDraggable) {
          this.sliderInstance.slider.allowTouchMove = isDraggable;
        }
      }

      playActiveMedia(selected) {
        const deferredMedia = selected.querySelector('product-model');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      setActiveMedia(variant) {
        if (!variant || !variant.hasOwnProperty('featured_media') || !variant.featured_media) return;

        if (this.sliderInstance.slider) {
          const slideIndex = variant.featured_media.position || 0;
          this.sliderInstance.slider.slideToLoop(slideIndex - 1);
        } else {
          this.sortMediaItems(variant);
        }
      }

      sortMediaItems(variant) {
        let newMedias = this.elements.mediaItems;

        // Reset ordering.
        newMedias.sort(function (a, b) {
          return a.dataset.mediaIndex - b.dataset.mediaIndex;
        });

        newMedias.some((media, index) => {
          if (media.dataset.mediaId == variant.featured_media.id) {
            const [element] = newMedias.splice(index, 1);
            newMedias.unshift(element);
            return true;
          }
        });

        this.elements.mediaList.innerHTML = '';
        newMedias.forEach((media) => {
          this.elements.mediaList.appendChild(media);
        });

        if (!FoxTheme.config.mqlMobile && this.context !== 'quickview') {
          const selectedMedia = this.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
          if (selectedMedia) {
            window.scrollTo({ top: selectedMedia.offsetTop, behavior: 'smooth' });
          }
        }
      }
    }
  );
}
